import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Schedule"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.75049 2.25V4.25098H16.2495V2.25H17.7495V4.25098H20.9995C21.966 4.25098 22.7495 5.03448 22.7495 6.00098V19.001C22.7495 19.9675 21.966 20.751 20.9995 20.751H2.99951C2.03301 20.751 1.24951 19.9675 1.24951 19.001V6.00098C1.24951 5.03448 2.03301 4.25098 2.99951 4.25098H6.25049V2.25H7.75049ZM16.2495 5.75098V7.75H17.7495V5.75098H20.9995C21.1376 5.75098 21.2495 5.86291 21.2495 6.00098V19.001C21.2495 19.139 21.1376 19.251 20.9995 19.251H2.99951C2.86144 19.251 2.74951 19.139 2.74951 19.001V6.00098C2.74951 5.86291 2.86144 5.75098 2.99951 5.75098H6.25049V7.75H7.75049V5.75098H16.2495ZM13.2505 10.749H6.25049V12.249H13.2505V10.749ZM6.25049 14.751H17.7505V16.251H6.25049V14.751Z"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Schedule.vue"]]);
